module.exports = "<div class=\"d3-box-plotter\" #d3BoxplotChartRef> </div>\r\n"